import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {withFormsy} from 'formsy-react';
import styles from './Input.pcss';

class Input extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        id: PropTypes.string,
        value: PropTypes.string,
        required: PropTypes.bool,
        mask: PropTypes.string,
        pattern: PropTypes.string,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        onMouseEnter: PropTypes.func,
        onMouseLeave: PropTypes.func,
        onChange: PropTypes.func,
        setValue: PropTypes.func,
        isValid: PropTypes.func,
        formatValue: PropTypes.func,
        autoComplete: PropTypes.string,
        getErrorMessage: PropTypes.func,
        showError: PropTypes.func,
        isPristine: PropTypes.func,
        type: PropTypes.oneOf([
            'date',
            'datetime',
            'email',
            'hidden',
            'number',
            'password',
            'range',
            'search',
            'tel',
            'text',
            'time',
            'url'
        ]),
        placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    };

    handleChange = event => {
        const {required, onChange} = this.props;
        let {value} = event.currentTarget;
        if (required && value === ' ') {
            value = '';
        }
        if (this.props.formatValue) {
            value = this.props.formatValue(value);
        }
        this.props.setValue(value);
        if (onChange) {
            event.currentTarget.value = value;
            onChange(event);
        }
    };

    static defaultProps = {
        className: styles.input
    };

    render() {
        const {
            id,
            name,
            type,
            value = '',
            mask = '',
            disabled,
            autoComplete,
            onMouseEnter,
            onMouseLeave,
            pattern,
            required
        } = this.props;

        let {className, placeholder} = this.props;
        if (['hidden', 'range'].indexOf(type) !== -1) {
            className = null;
        } else if (value) {
            className = cx(className, styles.filled);
        }

        placeholder = required && placeholder ? `${placeholder} *` : placeholder || '';

        return (
            <div className={className}>
                <input
                    className={
                        !this.props.isPristine() && !this.props.isValid() ? styles.active : ''
                    }
                    id={id}
                    type={type || 'text'}
                    name={name}
                    disabled={disabled}
                    value={value || mask}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onChange={this.handleChange}
                    autoComplete={autoComplete}
                    pattern={pattern}
                    required={required}
                />
                {type !== 'hidden' && (
                    <label id={`label-${id || name}`} htmlFor={name}>
                        {placeholder}
                    </label>
                )}
                {!this.props.isPristine() && (this.props.showError() || !this.props.isValid()) && (
                    <span>{this.props.getErrorMessage()}</span>
                )}
            </div>
        );
    }
}

export default withFormsy(Input);
